// Utility functions for Vulcan View Dashboard

// Format hashrate for Litecoin (comes in MH/s, show as GH/s)
export const formatLitecoinHashrate = (hashrateInMH: number): string => {
  const ghValue = hashrateInMH / 1000; // Convert MH/s to GH/s
  return `${ghValue.toFixed(3)} GH/s`;
};

// Format hashrate for SHA256 (comes in MH/s, show as GH/s)
export const formatSHA256Hashrate = (hashrateInTH: number): string => {
  return `${hashrateInTH.toFixed(3)} TH/s`;
};

export const formatDogecoinHashrate = (hashrateInMH: number): string => {
  const ghValue= hashrateInMH /1000;
  return `${ghValue.toFixed(3)} GH/s`;
};

// Generic hashrate formatter (legacy - kept for compatibility)
export const formatHashrate = (hashrate: number): string => {
  // This is a fallback - prefer specific formatters above
  const units = ['H/s', 'KH/s', 'MH/s', 'GH/s', 'TH/s', 'PH/s'];
  let unitIndex = 0;
  let value = hashrate;

  while (value >= 1000 && unitIndex < units.length - 1) {
    value /= 1000;
    unitIndex++;
  }

  return `${value.toFixed(3)} ${units[unitIndex]}`;
};

export const formatCurrency = (amount: number, currency = 'USD'): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 6
  }).format(amount);
};

export const formatPercentage = (value: number): string => {
  return `${(value * 100).toFixed(2)}%`;
};

export const formatTimeAgo = (timestamp: number): string => {
  const now = Date.now();
  const diff = now - timestamp;
  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 0) return `${days}d ago`;
  if (hours > 0) return `${hours}h ago`;
  if (minutes > 0) return `${minutes}m ago`;
  return `${seconds}s ago`;
};

export const getStatusColor = (status: string): string => {
  const colors = {
    online: '#2ECC71',
    offline: '#E74C3C',
    error: '#F39C12',
    warning: '#F1C40F'
  };
  return colors[status as keyof typeof colors] || '#95A5A6';
};

export const calculateProfitability = (
  hashrate: number,
  algorithm: string,
  profitabilityData: any[]
): number => {
  const algorithmData = profitabilityData.find(p => p.algorithm === algorithm);
  if (!algorithmData) return 0;
  
  return (hashrate * algorithmData.profitability) / 1000000; // Assuming profitability is per MH/s
};

export const debounce = <T extends (...args: any[]) => any>(
  func: T,
  delay: number
): ((...args: Parameters<T>) => void) => {
  let timeoutId: NodeJS.Timeout;
  return (...args: Parameters<T>) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), delay);
  };
};